<script setup lang="ts">
import Modal from "./Modal.vue";
import { ref } from "vue";

defineProps<{
  isForMultipleProducts: boolean;
}>();

const declineReason = ref("");

function isDeclineReasonEmpty() {
  const trimmed = declineReason.value.trim();
  return trimmed === "";
}
</script>

<template>
  <Modal
    @actioned="$emit('declineButtonClicked', declineReason)"
    :isActionButtonDisabled="isDeclineReasonEmpty()"
    actionColor="red"
  >
    <template #header>Decline application</template>
    <template #body>
      <p class="mb-4">
        Are you sure you want to decline
        <span v-if="isForMultipleProducts"> these products? </span>
        <span v-else> this product?</span>
        Doing so will prevent this customer from placing orders for the selected
        <span v-if="isForMultipleProducts"> products.</span>
        <span v-else> product.</span>
      </p>

      <h2 class="mb-2 text-lg font-semibold">Reason for decline</h2>

      <p class="mb-4 text-sm text-gray-500">
        The reason will be sent to a Runa staff member and only communicated if
        a customer asks.
      </p>

      <textarea
        v-model="declineReason"
        rows="4"
        class="block w-full rounded-lg bg-gray-100 p-2.5 text-sm text-gray-800 focus:border-blue-300 focus:ring-blue-500"
      />
    </template>
    <template #action-button> Decline </template>
  </Modal>
</template>
